/* @ngInject */
const myMovementForm = (
  $$autocomplete,
  $$movement,
  toaster
) => {
  return {
    restrict: 'E',
    scope: {
      myMovement: '=',
    },
    template: require('./myMovementForm.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.fieldsOptions = $$movement.metadata.fields
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: async (scope, element, attrs, ctrl) => {
        try {
          scope.ids = await $$autocomplete.request.get('id', 'wagons')
        } catch (error) {
          toaster.error(error)
        }
      },
    },
  }
}

export default myMovementForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/movement/directives/forms/myMovementForm.js